import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
// import myvue from '@/components/myvue'
// import home from '@/components/home'
// import Login from '@/component/Login'
// import Login from '../components/Login'
// // import Account from '@/components/account'
// // import Dashboard from '@/components/Dashboard'
// import Bdlp from '@/components/bdlp'
// import BdlpRunTask from '@/components/runtask'
// import Sdxy from '@/components/sdxy'
// import Keep from '@/components/keep'

// import BdlpIos from '@/components/components/ios-device-auth'
// import BdlpAndroid from '@/components/components/android-device-auth'

Vue.use(Router)

// const chatWindow = resolve => require(['@/components/chatWindow'], resolve)

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('../components/Login')
    },
    // {
    //   path: '/',
    //   name: 'Dashboard',
    //   component: Dashboard
    // }
    {
      path: '/bdlp',
      name: 'BdlpIndex',
      component: () => import('@/components/bdlp')
    },
    {
      path: '/bdlpruntask',
      name: 'BdlpRunTask',
      component: () => import('@/components/bdlp/direct-to')
    },
    {
      path: '/bdlp/stu',
      name: 'BdlpStuPage',
      component: () => import('@/components/bdlp/stu-page')
    },
    {
      path: '/',
      redirect: '/bdlp'
    },
    {
      path: '/bdlp/ios',
      name: 'BdlpIos',
      component: () => import('@/components/components/ios-device-auth')
    },
    {
      path: '/bdlp/android',
      name: 'BdlpAndroid',
      component: () => import('@/components/components/android-device-auth')
    },

    // {
    //   path: '/sdxy',
    //   name: 'SdxyIndex',
    //   component: () => import('@/components/sdxy')
    // },
    {
      path: '/sdxy',
      name: 'SdxyStuPage',
      component: () => import('@/components/sdxy/stu-page')
    },

    {
      path: '/keep',
      name: 'KeepIndex',
      component: () => import('@/components/keep')
    },

    {
      path: '/ypsj',
      name: 'YpsjStuPage',
      component: () => import('@/components/ypsj/stu-page')
    },
    {
      path: '/ymty',
      name: 'YmtyStuPage',
      component: () => import('@/components/ymty/stu-page')
    },
    {
      path: '/yyd',
      name: 'YydStuPage',
      component: () => import('@/components/yyd/stu-page')
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js